module.exports = "//img1.rrcimg.com/_next/static/src/assets/video_1yb3d.png";